import './styles/tokens.css';
import './styles/base.css';
import './styles/components.css';
import { App } from './app';

const root = document.getElementById('app');
if (root) {
  new App(root).init();
}
